import { ExpenseDto, ExpenseDriverOptionDto } from '../models/expense-api.model';

/**
 * Datos semilla del módulo de Gastos, en el formato EXACTO de la Tracking API
 * (PascalCase), para que el mock ejercite el mismo mapper que la implementación
 * real y cualquier fallo de mapeo se vea en desarrollo.
 *
 * Reproduce deliberadamente las dos rarezas de los datos de desarrollo:
 * filas históricas sin `ExpenseId`, `Status`, `ReportedAt` ni `Description`, y
 * categorías numéricas heredadas (`"1"`, `"2"`, `"3"`) sin traducción conocida.
 *
 * ⚠️ Este fichero desaparece cuando `environment.features.expensesMock` pase a
 * `false` de forma definitiva.
 */

export const MOCK_DRIVERS: readonly ExpenseDriverOptionDto[] = [
  { driverId: '22adffda-aea6-47b8-a1d1-8d9143650a09', fullName: 'María Queralt' },
  { driverId: '3b1e77c2-4a5d-4c11-9f0e-1a2b3c4d5e6f', fullName: 'María García' },
  { driverId: '7c2f18a4-9b3e-4d55-8a71-2b3c4d5e6f70', fullName: 'Germán Núñez' },
  { driverId: '9d3a29b5-1c4f-4e66-9b82-3c4d5e6f7081', fullName: 'Raquel Vázquez' },
  { driverId: '1e4b3ac6-2d50-4f77-8c93-4d5e6f708192', fullName: 'Elena Perera' },
  { driverId: '2f5c4bd7-3e61-4088-9da4-5e6f708192a3', fullName: 'Sofía Téllez' },
  { driverId: '306d5ce8-4f72-4199-8eb5-6f708192a3b4', fullName: 'Adrián Bonet' },
  { driverId: '417e6df9-5083-42aa-9fc6-708192a3b4c5', fullName: 'Nuria Alcázar' },
];

export const MOCK_EXPENSES: readonly ExpenseDto[] = [
    {
      "ExpenseId": "00000001-0000-4000-8000-000000000001",
      "NodeId": "B-7100A0-1",
      "OrderHash": "B-7100A0",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-01T08:00:00",
      "DriverId": "22adffda-aea6-47b8-a1d1-8d9143650a09",
      "DriverName": "María Queralt",
      "LicensePlate": "0922GYC",
      "Category": "fuel-not-included",
      "Description": "Repostaje en gasolinera Shell",
      "Amount": 34.59,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-fuel.svg",
    },
    {
      "ExpenseId": "00000002-0000-4000-8000-000000000001",
      "NodeId": "B-7101A1-1",
      "OrderHash": "B-7101A1",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-02T09:07:00",
      "DriverId": "3b1e77c2-4a5d-4c11-9f0e-1a2b3c4d5e6f",
      "DriverName": "María García",
      "LicensePlate": "4567HGF",
      "Category": "toll",
      "Description": "AP-7 tramo Castellon-Valencia",
      "Amount": 50.62,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": "00000003-0000-4000-8000-000000000001",
      "NodeId": "B-7102A2-1",
      "OrderHash": "B-7102A2",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-03T10:14:00",
      "DriverId": "7c2f18a4-9b3e-4d55-8a71-2b3c4d5e6f70",
      "DriverName": "Germán Núñez",
      "LicensePlate": "1345DFG",
      "Category": "parking",
      "Description": "Parking aeropuerto T4",
      "Amount": 67.72,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000004-0000-4000-8000-000000000001",
      "NodeId": "B-7103A3-1",
      "OrderHash": "B-7103A3",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-04T11:21:00",
      "DriverId": "9d3a29b5-1c4f-4e66-9b82-3c4d5e6f7081",
      "DriverName": "Raquel Vázquez",
      "LicensePlate": "8713JGR",
      "Category": "wash",
      "Description": "Lavado exterior antes de entrega",
      "Amount": 95.76,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": null,
    },
    {
      "ExpenseId": "00000005-0000-4000-8000-000000000001",
      "NodeId": "B-7104A4-1",
      "OrderHash": "B-7104A4",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": null,
      "ClientName": null,
      "ReportedAt": "2026-08-05T12:28:00",
      "DriverId": "1e4b3ac6-2d50-4f77-8c93-4d5e6f708192",
      "DriverName": "Elena Perera",
      "LicensePlate": "7162KGG",
      "Category": "workshop",
      "Description": "Revision de neumaticos",
      "Amount": 16.67,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-maintenance.svg",
    },
    {
      "ExpenseId": "00000006-0000-4000-8000-000000000001",
      "NodeId": "B-7105A5-1",
      "OrderHash": "B-7105A5",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-06T13:35:00",
      "DriverId": "2f5c4bd7-3e61-4088-9da4-5e6f708192a3",
      "DriverName": "Sofía Téllez",
      "LicensePlate": "4012LNS",
      "Category": "payment-itv",
      "Description": "Tasa ITV segunda inspeccion",
      "Amount": 46.56,
      "Status": 1,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-maintenance.svg",
    },
    {
      "ExpenseId": "00000007-0000-4000-8000-000000000001",
      "NodeId": "B-7106A6-1",
      "OrderHash": "B-7106A6",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-07T14:42:00",
      "DriverId": "306d5ce8-4f72-4199-8eb5-6f708192a3b4",
      "DriverName": "Adrián Bonet",
      "LicensePlate": "5521MTR",
      "Category": "fuel-not-included",
      "Description": "Repostaje Repsol A-4",
      "Amount": 74.76,
      "Status": 1,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-fuel.svg",
    },
    {
      "ExpenseId": "00000008-0000-4000-8000-000000000001",
      "NodeId": "B-7107A7-1",
      "OrderHash": "B-7107A7",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-08T15:49:00",
      "DriverId": "417e6df9-5083-42aa-9fc6-708192a3b4c5",
      "DriverName": "Nuria Alcázar",
      "LicensePlate": "9003BBQ",
      "Category": "toll",
      "Description": "AP-2 Zaragoza-Lleida",
      "Amount": 48.6,
      "Status": 1,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": "00000009-0000-4000-8000-000000000001",
      "NodeId": "B-7108A8-1",
      "OrderHash": "B-7108A8",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-09T16:56:00",
      "DriverId": "22adffda-aea6-47b8-a1d1-8d9143650a09",
      "DriverName": "María Queralt",
      "LicensePlate": "0922GYC",
      "Category": "parking",
      "Description": "Parking zona azul centro",
      "Amount": 58.33,
      "Status": 2,
      "RejectionReason": "El ticket no corresponde al servicio",
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000010-0000-4000-8000-000000000001",
      "NodeId": "B-7109A9-1",
      "OrderHash": "B-7109A9",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-10T08:03:00",
      "DriverId": "3b1e77c2-4a5d-4c11-9f0e-1a2b3c4d5e6f",
      "DriverName": "María García",
      "LicensePlate": "4567HGF",
      "Category": "wash",
      "Description": "Lavado exterior antes de entrega",
      "Amount": 3.93,
      "Status": 2,
      "RejectionReason": "La foto no se lee bien",
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000011-0000-4000-8000-000000000001",
      "NodeId": "B-7110A0-1",
      "OrderHash": "B-7110A0",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-11T09:10:00",
      "DriverId": "7c2f18a4-9b3e-4d55-8a71-2b3c4d5e6f70",
      "DriverName": "Germán Núñez",
      "LicensePlate": "1345DFG",
      "Category": "workshop",
      "Description": "Ajuste de presion de neumaticos",
      "Amount": 85.51,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": null,
    },
    {
      "ExpenseId": "00000012-0000-4000-8000-000000000001",
      "NodeId": "B-7111A1-1",
      "OrderHash": "B-7111A1",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": null,
      "ClientName": null,
      "ReportedAt": "2026-08-12T10:17:00",
      "DriverId": "9d3a29b5-1c4f-4e66-9b82-3c4d5e6f7081",
      "DriverName": "Raquel Vázquez",
      "LicensePlate": "8713JGR",
      "Category": "payment-itv",
      "Description": "Tasa ITV vehiculo ligero",
      "Amount": 9.84,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-maintenance.svg",
    },
    {
      "ExpenseId": "00000013-0000-4000-8000-000000000001",
      "NodeId": "B-7112A2-1",
      "OrderHash": "B-7112A2",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-13T11:24:00",
      "DriverId": "1e4b3ac6-2d50-4f77-8c93-4d5e6f708192",
      "DriverName": "Elena Perera",
      "LicensePlate": "7162KGG",
      "Category": "fuel-not-included",
      "Description": "Repostaje en gasolinera Shell",
      "Amount": 26.83,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-fuel.svg",
    },
    {
      "ExpenseId": "00000014-0000-4000-8000-000000000001",
      "NodeId": "B-7113A3-1",
      "OrderHash": "B-7113A3",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-14T12:31:00",
      "DriverId": "2f5c4bd7-3e61-4088-9da4-5e6f708192a3",
      "DriverName": "Sofía Téllez",
      "LicensePlate": "4012LNS",
      "Category": "toll",
      "Description": "AP-7 tramo Castellon-Valencia",
      "Amount": 8.34,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": "00000015-0000-4000-8000-000000000001",
      "NodeId": "B-7114A4-1",
      "OrderHash": "B-7114A4",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-01T13:38:00",
      "DriverId": "306d5ce8-4f72-4199-8eb5-6f708192a3b4",
      "DriverName": "Adrián Bonet",
      "LicensePlate": "5521MTR",
      "Category": "parking",
      "Description": "Parking aeropuerto T4",
      "Amount": 12.95,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000016-0000-4000-8000-000000000001",
      "NodeId": "B-7115A5-1",
      "OrderHash": "B-7115A5",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-02T14:45:00",
      "DriverId": "417e6df9-5083-42aa-9fc6-708192a3b4c5",
      "DriverName": "Nuria Alcázar",
      "LicensePlate": "9003BBQ",
      "Category": "wash",
      "Description": "Lavado integral",
      "Amount": 59.89,
      "Status": 1,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000017-0000-4000-8000-000000000001",
      "NodeId": "B-7116A6-1",
      "OrderHash": "B-7116A6",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-03T15:52:00",
      "DriverId": "22adffda-aea6-47b8-a1d1-8d9143650a09",
      "DriverName": "María Queralt",
      "LicensePlate": "0922GYC",
      "Category": "workshop",
      "Description": "Cambio de limpiaparabrisas",
      "Amount": 40.31,
      "Status": 1,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-maintenance.svg",
    },
    {
      "ExpenseId": "00000018-0000-4000-8000-000000000001",
      "NodeId": "B-7117A7-1",
      "OrderHash": "B-7117A7",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-04T16:59:00",
      "DriverId": "3b1e77c2-4a5d-4c11-9f0e-1a2b3c4d5e6f",
      "DriverName": "María García",
      "LicensePlate": "4567HGF",
      "Category": "payment-itv",
      "Description": "Tasa ITV segunda inspeccion",
      "Amount": 48.07,
      "Status": 1,
      "RejectionReason": null,
      "ReceiptUrl": null,
    },
    {
      "ExpenseId": "00000019-0000-4000-8000-000000000001",
      "NodeId": "B-7118A8-1",
      "OrderHash": "B-7118A8",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-05T08:06:00",
      "DriverId": "7c2f18a4-9b3e-4d55-8a71-2b3c4d5e6f70",
      "DriverName": "Germán Núñez",
      "LicensePlate": "1345DFG",
      "Category": "fuel-not-included",
      "Description": "Repostaje Repsol A-4",
      "Amount": 49.42,
      "Status": 2,
      "RejectionReason": "El ticket no corresponde al servicio",
      "ReceiptUrl": "assets/images/expenses/receipt-fuel.svg",
    },
    {
      "ExpenseId": "00000020-0000-4000-8000-000000000001",
      "NodeId": "B-7119A9-1",
      "OrderHash": "B-7119A9",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-06T09:13:00",
      "DriverId": "9d3a29b5-1c4f-4e66-9b82-3c4d5e6f7081",
      "DriverName": "Raquel Vázquez",
      "LicensePlate": "8713JGR",
      "Category": "toll",
      "Description": "Tunel de Vallvidrera",
      "Amount": 17.75,
      "Status": 2,
      "RejectionReason": "La foto no se lee bien",
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": "00000021-0000-4000-8000-000000000001",
      "NodeId": "B-7120A0-1",
      "OrderHash": "B-7120A0",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-07T10:20:00",
      "DriverId": "1e4b3ac6-2d50-4f77-8c93-4d5e6f708192",
      "DriverName": "Elena Perera",
      "LicensePlate": "7162KGG",
      "Category": "parking",
      "Description": "Parking taller colaborador",
      "Amount": 35.56,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000022-0000-4000-8000-000000000001",
      "NodeId": "B-7121A1-1",
      "OrderHash": "B-7121A1",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": "2026-08-08T11:27:00",
      "DriverId": "2f5c4bd7-3e61-4088-9da4-5e6f708192a3",
      "DriverName": "Sofía Téllez",
      "LicensePlate": "4012LNS",
      "Category": "wash",
      "Description": "Lavado integral",
      "Amount": 67.04,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-parking.svg",
    },
    {
      "ExpenseId": "00000023-0000-4000-8000-000000000001",
      "NodeId": "B-7122A2-1",
      "OrderHash": "B-7122A2",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": "2026-08-09T12:34:00",
      "DriverId": "306d5ce8-4f72-4199-8eb5-6f708192a3b4",
      "DriverName": "Adrián Bonet",
      "LicensePlate": "5521MTR",
      "Category": "workshop",
      "Description": "Revision de neumaticos",
      "Amount": 65.5,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-maintenance.svg",
    },
    {
      "ExpenseId": "00000024-0000-4000-8000-000000000001",
      "NodeId": "B-7123A3-1",
      "OrderHash": "B-7123A3",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": "2026-08-10T13:41:00",
      "DriverId": "417e6df9-5083-42aa-9fc6-708192a3b4c5",
      "DriverName": "Nuria Alcázar",
      "LicensePlate": "9003BBQ",
      "Category": "payment-itv",
      "Description": "Tasa ITV segunda inspeccion",
      "Amount": 46.29,
      "Status": 0,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-maintenance.svg",
    },
    {
      "ExpenseId": null,
      "NodeId": "B-TRANSFER-HIST-1-1",
      "OrderHash": "B-TRANSFER-HIST-1",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": null,
      "DriverId": "22adffda-aea6-47b8-a1d1-8d9143650a09",
      "DriverName": null,
      "LicensePlate": "1234ABC",
      "Category": "1",
      "Description": null,
      "Amount": 15,
      "Status": null,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": null,
      "NodeId": "B-TRANSFER-HIST-2-1",
      "OrderHash": "B-TRANSFER-HIST-2",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": null,
      "DriverId": "3b1e77c2-4a5d-4c11-9f0e-1a2b3c4d5e6f",
      "DriverName": null,
      "LicensePlate": "1234ABC",
      "Category": "2",
      "Description": null,
      "Amount": 2,
      "Status": null,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": null,
      "NodeId": "B-TRANSFER-HIST-3-1",
      "OrderHash": "B-TRANSFER-HIST-3",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": null,
      "DriverId": "7c2f18a4-9b3e-4d55-8a71-2b3c4d5e6f70",
      "DriverName": null,
      "LicensePlate": "1234ABC",
      "Category": "3",
      "Description": null,
      "Amount": 1,
      "Status": null,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": null,
      "NodeId": "B-TRANSFER-HIST-4-1",
      "OrderHash": "B-TRANSFER-HIST-4",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000001",
      "ClientName": "Talleres Pepe",
      "ReportedAt": null,
      "DriverId": "9d3a29b5-1c4f-4e66-9b82-3c4d5e6f7081",
      "DriverName": null,
      "LicensePlate": "1234ABC",
      "Category": "1",
      "Description": null,
      "Amount": 25,
      "Status": null,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": null,
      "NodeId": "B-TRANSFER-HIST-5-1",
      "OrderHash": "B-TRANSFER-HIST-5",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000002",
      "ClientName": "Autos del Norte",
      "ReportedAt": null,
      "DriverId": "1e4b3ac6-2d50-4f77-8c93-4d5e6f708192",
      "DriverName": null,
      "LicensePlate": "1234ABC",
      "Category": "fuel-not-included",
      "Description": null,
      "Amount": 65,
      "Status": null,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    },
    {
      "ExpenseId": null,
      "NodeId": "B-TRANSFER-HIST-6-1",
      "OrderHash": "B-TRANSFER-HIST-6",
      "ZoneId": "990fdc23-543d-4840-90f6-3757cea5790d",
      "ClientId": "a1b2c3d4-0000-4000-8000-000000000003",
      "ClientName": "Renting Delta",
      "ReportedAt": null,
      "DriverId": "2f5c4bd7-3e61-4088-9da4-5e6f708192a3",
      "DriverName": null,
      "LicensePlate": "1234ABC",
      "Category": "toll",
      "Description": null,
      "Amount": 4.5,
      "Status": null,
      "RejectionReason": null,
      "ReceiptUrl": "assets/images/expenses/receipt-toll.svg",
    }
  ];
